import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

/**
 * Adds data-di-mask attribute for Medallia DXA PII masking.
 * Usage: <div appPiiMask="name">{{ clientName }}</div>
 */
@Directive({
  selector: '[appPiiMask]',
  standalone: true,
})
export class PiiMaskDirective implements OnInit {
  /**
   * Optional mask type identifier for categorizing PII types
   * Examples: 'name', 'dob', 'ssn', 'address', 'zip'
   */
  @Input('appPiiMask') maskType: string = '';

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.applyMaskAttributes();
  }

  private applyMaskAttributes(): void {
    const element = this.el.nativeElement;

    // Apply Medallia DXA masking attribute (per Vanguard DXA Integration Guide)
    // DXA recognizes the data-di-mask attribute and masks content in session replays
    this.renderer.setAttribute(element, 'data-di-mask', '');

    // Optionally add mask type for debugging/categorization
    if (this.maskType) {
      this.renderer.setAttribute(element, 'data-pii-type', this.maskType);
    }
  }
}
